const HLS = require('hls-parser');
import Rendition from '../Resource/Rendition';
import Segment from '../Resource/Segment';
export default class HlsParser {
    static parse(url, textData, resource) {
        const playlist = HLS.parse(textData);
        // You can access the playlist as a JS object
        if (playlist.isMasterPlaylist) {
            if (playlist.variants != undefined)
                playlist.variants.forEach(function (value) {
                    let rendition = new Rendition();
                    rendition.bandwidth = value.bandwidth;
                    rendition.uri = value.uri;
                    resource.addRendition(value.uri, rendition);
                    if (value.audio != undefined)
                        value.audio.forEach(function (audioEntry) {
                            let newAudioRendition = new Rendition();
                            newAudioRendition.uri = audioEntry.uri;
                            newAudioRendition.isAudio = true;
                            resource.addRendition(audioEntry.uri, newAudioRendition);
                        });
                });
        }
        else {
            let done = false;
            resource.getRenditions().forEach((value, key) => {
                if (url.endsWith(key)) {
                    if (playlist.segments != undefined)
                        playlist.segments.forEach(function (segment) {
                            let newSegment = new Segment();
                            newSegment.uri = segment.uri;
                            value.segments.set(segment.uri, newSegment);
                        });
                    if (playlist.targetDuration != undefined)
                        value.targetDuration = playlist.targetDuration;
                    done = true;
                }
            });
        }
    }
}
